import React from "react";

import { TopBannerWrapper } from "@components/Common/Design/TopBannerWrapper";

import "@components/Common/Design/index.css";

export function TopBanner(): JSX.Element {
    return <TopBannerWrapper />;
}
